import React, { Component } from "react";
 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Carousel } from 'react-bootstrap';

import {
  faChevronLeft,
  faChevronRight,
  faPlus,
  faMinus,
  faShoppingCart,
  faCreditCard
} from "@fortawesome/free-solid-svg-icons";

import FacebookShareButton from "./FacebookShareButton";
// import TwitterShareButton from "./TwitterShareButton";
 
//style
import "./ProductPage.sass";
//Product Information
import ProductInformation from './ProductInformation'
//global components
import MainMenu from '../../_components/MainMenu';
import MainFooter from '../../_components/MainFooter';
import PreLoader from "../../_components/PreLoader";
//services
import { menuService } from "../../_services/menu.service";
import { productService } from "../../_services/product.service";
import { cartService } from '../../_services/cart.service';
import { postService } from "../../_services/post.service";
import { formatPrice } from "../../_helpers";

import Swal from 'sweetalert2/dist/sweetalert2.js'

import { Magnifier, MOUSE_ACTIVATION, TOUCH_ACTIVATION } from "react-image-magnifiers";
 
class ProductPage extends Component {
  constructor(props) {
    super(props);
 
    this.state = {
      loading: true,
      user: {
        details: {},
      },
      quantity: 1,
      menu: [],
      topbarMenu: {},
      product: {},
      category: {},
      branches: [],
      id: null,
      cart: {
        items: []
      }
    };

    this.handleAddToCartClick = this.handleAddToCartClick.bind(this);
  }
 
  

  quantityIncrement = () => {
    if (this.state.quantity >= 20) {
    } else {
      this.setState({ quantity: this.state.quantity + 1 });
    }
  };
 
  quantityDecrement = () => {
    if (this.state.quantity <= 1) {
    } else {
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };
 
  UpdateValue = (e) => {
    this.setState({ quantity: e.target.value });
  };

  handleAddToCartClick = (productId, callback) => {
    console.log(typeof productId);
    console.log(productId);
    console.log(this.state.quantity);

    cartService.getAllCart()
      .then(nonce => {
        console.log('Fetched nonce:', nonce); // Ensure nonce is fetched
        // Add the product to the cart using the fetched nonce
        return cartService.addToCart(productId, this.state.quantity, nonce);
      })
      .then(data => {
        console.log('Product added to cart:', data);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: data.name + " has been added to your shopping cart.",
          showConfirmButton: false,
          timer: 1500,
        });

        // Call the callback if provided
        if (callback) {
          callback();
        }
      })
      .catch(error => {
        console.error('Failed to add product to cart:', error);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "An error occurred when retrieving your cart.",
          showConfirmButton: false,
          timer: 3000,
        });
      });
  };

// addToCart(productId) {
//     // Simulate an async add to cart operation
//     return new Promise((resolve, reject) => {
//       // Simulate success
//       setTimeout(() => {
//         resolve();
//       }, 1000);
//     });
//   }

  // addToCart(id, name, slug, image, cost, callback) {
  //   const { cart, quantity = 1 } = this.state;

  //   if (!cart.items) {
  //     Swal.fire({
  //       position: "top-end",
  //       icon: "error",
  //       title: "An error occured when retrieving your cart.",
  //       showConfirmButton: false,
  //       timer: 3000,
  //     });
  //     return false;
  //   }
    
  //   cartService.getItems().then(({ items, ...cart }) => {
  //     const newItems = items.reduce((acc, obj) => {
  //       const index = acc.findIndex((v) => v.p === obj.p);
  //       if (index > -1) {
  //         acc[index].q += obj.q
  //         return acc;
  //       };
  //       return acc.concat(obj);
  //     }, [{
  //       p: id,
  //       n: name,
  //       i: image,
  //       s: slug,
  //       c: cost,
  //       q: quantity,
  //     }]);

  //     cartService.addItem({
  //       ...cart,
  //       items: newItems
  //     }).then((result) => {
  //       if (result.success) {
  //         if (callback) {
  //           return callback()
  //         }

  //         Swal.fire({
  //           position: "top-end",
  //           icon: "success",
  //           title: name + " has been added to your shopping cart.",
  //           showConfirmButton: false,
  //           timer: 1500,
  //         });
  //       }
  //     });
  //   });
  // }
 
  componentDidMount() {
    let { slug } = this.props.match.params;
    const user = JSON.parse(localStorage.getItem("user"));
 
    if (user && Date.now() < user.expiresAt) {
      this.setState({
        user: user,
      });
    } else {
      this.setState({
        user: {
          details: {},
        },
      });
    }
   
    Promise.allSettled([
      productService.getProductBySlug(slug)
        .then(product => {

          if(product.categories.length > 0){
            this.setState({ product, category: product.categories[0]})
          }
        }),
      menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu })),
      menuService.getMenuByName('default').then(menu => this.setState({ menu })),
      postService.getBranchesFooter('branch').then(branches => this.setState({ branches })),
      // .then(product => this.setState({ product }))
      //   productService.getBySlug(slug)
      //     .then(product => menuService.getMenuByName(product && product.name)
      //     .then(menu => categoryService.getById(product && product.category)
      //     .then(category => this.setState({ category, menu, product})))),
      //   branchService
      //     .getAll({ page: 1, items: 5, filter: { homepage: true} })
      //     .then((branches) => this.setState({ branches })),
      // cartService.getAllCart().then(cart => this.setState({ cart }))
      //   menuService.getMenuByName('Topbar').then(topbarMenu => this.setState({ topbarMenu }))
    ]).then(() => this.setState({ loading: false }))
  }

  render() {
    const { loading, menu, topbarMenu, cart, branches, product, user, category } = this.state;
    

      return (
        <React.Fragment>
           <PreLoader loading={loading} />
           <MainMenu user={user} menu={menu} cart={cart} topbarMenu={topbarMenu}/>
 
          <div className="jumbotron page-title py-5">
            <div className="container">
              <h1 className="text-white">{category.name || "Products"} </h1>
            </div>
          </div>
          {category && product && product.name ?
          <section className="single-product-section">
            <div className="container">
              <div className="row mb-5">
                <div className="col-12">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-transparent m-0 ">
                      <li className="breadcrumb-item">
                        <a className="nav-link d-inline" href="/">
                          Home
                        </a>
                      </li>
                      <li className="breadcrumb-item">
                        <a className="nav-link d-inline" href={"/" + category.slug || "/"}>
                        {category.name || "Products"}
                        </a>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        {product.name || ''}
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div
                    id="individualProductCarousel"
                    className="carousel slide individual-product-carousel"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
            
                      {product.images && product.images.length <= 1 
                        ? 
                        product.images.map((image , index) => {
                          return (
                            <Carousel.Item className={index === 0 ? "active" : ""} key={`${product._id}${index}`}>
                              <Magnifier
                                style={{ cursor: "zoom-in" }}
                                className="d-block w-100"
                                imageSrc={image.src}
                                imageAlt="..."
                                mouseActivation={MOUSE_ACTIVATION.CLICK}
                                touchActivation={TOUCH_ACTIVATION.TAP}
                                dragToMove={false}
                              />
                            </Carousel.Item>
                          )
                        })
                        :
                        product.images.slice(1).map((image , index) => {
                          return (
                            <Carousel.Item className={index === 0 ? "active" : ""} key={`${product._id}${index}`}>
                              <Magnifier
                                style={{ cursor: "zoom-in" }}
                                className="d-block w-100"
                                imageSrc={image.src}
                                imageAlt="..."
                                mouseActivation={MOUSE_ACTIVATION.CLICK}
                                touchActivation={TOUCH_ACTIVATION.TAP}
                                dragToMove={false}
                              />
                            </Carousel.Item>
                          )
                        })
                    }

                      {/* {product.images && product.images.map((image , index) => {
                          return (
                            <Carousel.Item className={index === 0 ? "active" : ""} key={`${product._id}${index}`}>
                            <Magnifier
                              style={{ cursor: "zoom-in" }}
                              className="d-block w-100"
                              imageSrc={image.src}
                              imageAlt="..."
                              mouseActivation={MOUSE_ACTIVATION.CLICK}
                              touchActivation={TOUCH_ACTIVATION.TAP}
                              dragToMove={false}
                            />
                          </Carousel.Item>)
                         }
                          )} */}
                     </div>
                    
                    <a
                      className="carousel-control-prev"
                      href="#individualProductCarousel"
                      role="button"
                      data-slide="prev"
                    >
                      <FontAwesomeIcon icon={faChevronLeft} size="2x" />
                      <span className="sr-only">Previous</span>
                    </a>
                    <a
                      className="carousel-control-next"
                      href="#individualProductCarousel"
                      role="button"
                      data-slide="next"
                    >
                      <FontAwesomeIcon icon={faChevronRight} size="2x" />
                      <span className="sr-only">Next</span>
                    </a>
                    <ol className="carousel-indicators">
                    {product.images && product.images.length <= 1 
                        ? 
                        product.images.map((row, index) => {
                          return(
                            <li
                            key={index}
                            data-target="#individualProductCarousel"
                            data-slide-to={index}
                            ></li>
                          )
                        })
                        :
                        product.images.slice(1).map((row, index) => {
                          return(
                            <li
                            key={index}
                            data-target="#individualProductCarousel"
                            data-slide-to={index}
                            ></li>
                          )
                        })
                    }

                      {/* { product.images && product.images.map((row, index) => {
                        return(
                          <li
                          key={index}
                          data-target="#individualProductCarousel"
                          data-slide-to={index}
                        ></li>
                        )
                      })
                    } */}
                    </ol>
                  </div>
                </div>
                <div className="col-lg-6">
                  <h2>{formatPrice(product.price, { minimumFractionDigits: 0 })} 
                  {product.on_sale == true &&
                    <small><s className="text-muted">{formatPrice(product.regular_price, { minimumFractionDigits: 0 })}</s></small>
                  }
                  </h2>
                  <p className="lead pricing-lead"> {product.name} </p>
                  <p dangerouslySetInnerHTML={{ __html: product.short_description || ''}} />
                  <p className="availabilty-text">

                    <strong>Availabilty:</strong>{" "}
                    <span className={product.stock_quantity > 0 ? 'green' : 'red'} >{product.stock_quantity > 0 ? "In Stock" : "Out of Stock"} </span>
                  </p>
                  <div className="input-group my-3 quantity-counter">
                    <div className="input-group-prepend">
                      <label className="input-group-text bg-transparent pl-0">
                        Quantity:
                      </label>
                    </div>
 
                    <input
                      type="text"
                      className="form-control"
                      placeholder={this.state.quantity}
                      onChange={this.UpdateValue}
                      aria-label=""
                      aria-describedby=""
                    />
                    <div className="input-group-append" id="button-addon4">
                      <button
                        className="btn btn-outline-secondary"
                        onClick={this.quantityDecrement}
                        type="button"
                      >
                        <FontAwesomeIcon icon={faMinus} />
                      </button>

                      <button
                        className="btn btn-outline-secondary"
                        onClick={this.quantityIncrement}
                        type="button"
                      >
                        <FontAwesomeIcon icon={faPlus} />
                      </button>
                    </div>
                  </div>

                  <p className="availabilty-text d-flex">
                    <strong>Share:</strong>{" "}
                    <span>
                      <FacebookShareButton />
                      {/* <TwitterShareButton />  */}
                    </span> 
                  </p>
         
                  { product.stock_quantity > 0 ? (
                    <div className="d-flex my-5">
                    <button
                      className="btn  btn-lg mr-2 btn-block"
                      style={{ background: "#FFA162", color: "#fff" }}
                      onClick={() => {
                        this.handleAddToCartClick(product.id)

                      }}
                    >
                      <FontAwesomeIcon icon={faShoppingCart} /> ADD TO CART
                    </button>
 
                    <button
                      className="btn btn-primary btn-lg btn-block btn-paypal m-0"
                      onClick={() => this.handleAddToCartClick(product.id, () => (window.location = '/checkout'))}
                    >
                      <FontAwesomeIcon icon={faCreditCard} /> CHECK OUT
                    </button>
                  </div>
                   ) : (
                     <div className="d-flex my-5">
                      <button
                        disabled
                        className="btn  btn-lg mr-2 btn-block"
                        style={{ background: "#FFA162", color: "#fff" }}
                       >
                        <FontAwesomeIcon icon={faShoppingCart} /> ADD TO CART
                      </button>

                      <button
                        disabled
                        className="btn btn-primary btn-lg btn-block btn-paypal m-0"
                       >
                        <FontAwesomeIcon icon={faCreditCard} /> CHECK OUT
                      </button>
                      {/* <button
                        disabled
                        className="btn btn-primary btn-lg btn-block btn-paypal m-0"
                      >
                        Check out
                        <img
                          src="/korg_img/images/paypal.svg"
                          width="70"
                          alt="..."
                        />
                      </button> */}
                    </div>
                   )}
                </div>
              </div>
            </div>
          </section>
          :<center><img src="/korg_img/loader.gif" alt="loading..." /></center>
          }
          <ProductInformation product={product} cart={cart} />
          <MainFooter menu={menu} branches={branches} />
        </React.Fragment>
      );
    }
}
 
export {ProductPage};